const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-info",
    meta: {},
    name: "m-info",
    component: () => import("@/modules/minfo/RootView")
});

export default Routes;